import axios from "./axios";

const getCompanyDetails = (id) =>
  axios.get(`/users/company/${id}/`).then(
    (res) => res,
    (err) => err.response
  );

export { getCompanyDetails };
